import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { CaseCheckerActionResponse } from 'utils/types';

type RejectCaseCheckerFine = {
  fineId: string;
  reason: string;
};

const rejectCaseCheckerFine = async ({
  fineId,
  reason,
}: RejectCaseCheckerFine): Promise<CaseCheckerActionResponse> => {
  const response: AxiosResponse<CaseCheckerActionResponse> =
    await axiosInstance.post(`fine/${fineId}/case-checker/reject`, {
      reason,
    });
  return response.data;
};

const useRejectCaseCheckerFine = (): UseMutationResult<
  CaseCheckerActionResponse,
  Error,
  RejectCaseCheckerFine
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rejectCaseCheckerFine,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fine'] });
      queryClient.invalidateQueries({
        queryKey: ['case-checker-pending-cases'],
      });
    },
    onError: (error: Error) => {
      console.error('Error rejecting case checker fine:', error.message);
    },
  });
};

export default useRejectCaseCheckerFine;
